<div class="fc-container" [ngClass]="{ hidden: !isCalendarReady, 'read-only': isReadOnly }" #calendarContainer>
    <p *ngIf="!isReadOnly" class="field__label--secondary-color">
        Set regular availability hours by clicking on a day. Times shown are in {{ timezone | tzName }}
    </p>

    <full-calendar #calendar [options]="calendarOptions"></full-calendar>

    <common-bulma-modal [showModal]="showModal" (onHideModal)="handleCancelChanges()" #editTimeRanges>
        <div class="fc-modal-header">Edit {{ selectedWeekday | titlecase }} Availability</div>

        <div class="fc-toggle-container">
            <div class="ui toggle checkbox">
                <input
                    type="checkbox"
                    [(ngModel)]="isSelectedDateAvailable"
                    (ngModelChange)="handleUpdateAvailableDay($event, selectedWeekday)"
                />
                <label>Available</label>
            </div>
        </div>

        <ng-container *ngFor="let range of availabilityWindows[selectedWeekday]; let i = index">
            <common-time-range
                [index]="i"
                [weekday]="selectedWeekday"
                [timeRange]="range"
                [meetingLength]="meetingLength"
                [timeIntervals]="timeIntervals"
                [startEndTimeWindows]="availabilityWindows[selectedWeekday]"
                (onUpdateRange)="handleUpdateTimeRange($event)"
                (onRemoveRange)="handleRemoveTimeRange($event)"
            ></common-time-range>
        </ng-container>
        <div *ngIf="isBasicUser; else showDefaultButton" role="button" class="add-time-range-button disabled">
            <span>+ Add a time range.</span>
            <p class="upgrade">
                To add a Time Range please upgrade to Pro or Team Plan.
                <a target="_blank" href="/settings/billing">Upgrade</a>
            </p>
        </div>
        <ng-template #showDefaultButton>
            <div
                *ngIf="canAddMoreTimeRanges"
                role="button"
                class="fc-modal-add-range-button"
                (click)="handleAddTimeRange(selectedWeekday)"
            >
                + Add a time range
            </div>
        </ng-template>
        <div class="fc-modal-actions">
            <button class="ui button primary fc-modal-save-button" (click)="handleSave()">Save</button>
        </div>
    </common-bulma-modal>
</div>
